import React, { Dispatch, FC, SetStateAction } from 'react'
import { ExerciseInWorkout } from '@entities/exercise'
import { ExerciseDetailsScreen } from '@widgets/exercise/ExerciseDetailsView'
import '@pages/exerciseInfo/ui/exercise-info.css'

interface FullExerciseInfoProps {
	exercise: ExerciseInWorkout
	setIsShowingDescription: Dispatch<SetStateAction<boolean>>
}

export const FullExerciseInfoPage: FC<FullExerciseInfoProps> = ({
	exercise,
	setIsShowingDescription,
}) => {
	const exerciseDetails = {
		name: exercise.exercise_detail.name,
		description: exercise.exercise_detail.description,
		technique: exercise.exercise_detail.technique,
		muscle_group_codes: exercise.exercise_detail.muscle_group_codes,
		media: exercise.exercise_detail.media,
	}

	return (
		<ExerciseDetailsScreen
			exercise={exerciseDetails}
			onBack={() => setIsShowingDescription(false)}
		/>
	)
}
